<template>
  <div>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" @click="$router.push('/communication')" style="cursor: pointer">Comunicación</li>
            <li class="breadcrumb-item active" aria-current="page">Correos</li>
        </ol>
    </nav>
    <div class="px-4 py-3">
      <big-title>
        Plantillas <span>de correo</span>.
        <p class="text-subtitle mt-4">
          Apartado para administración de las plantillas de correo que se utilizan en el sistema de eventos y notificaciones
          del sistema.
        </p>
      </big-title>

      <vx-card :hidden="!onTableView" title="Lista de plantillas registradas">
        <vs-table class="mt-1" ref="table" :data="templates" :max-items="itemsPerPage" stripe search pagination noDataText="No hay registros disponibles">
          <div slot="header" class="ml-4 mb-6 flex items-center flex-grow justify-left">
            <span class="ml-2 mr-4">Mostrando {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ templates.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : templates.length }} de <strong>{{ templates.length }}</strong> </span>

            <vs-dropdown v-if="isMounted" vs-trigger-click class="cursor-pointer ml-4 items-per-page-handler">
              <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center font-medium">
                <span class="mr-2 text-sm">Regs. por página: {{ itemsPerPage}}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="updateItemsPerPage(it)" :key="it">
                  <span>{{it}}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <div class="ml-6">
              <vs-button size="small" icon="add_circle_outline" @click="startNewReg">Agregar</vs-button>
            </div>
            <div class="ml-6">
              <vs-button size="small" icon="send" color="#24c1a0" @click="sendTest">Enviar prueba</vs-button>
            </div>
          </div>

          <template slot="thead">
            <vs-th class="bold" sort-key="code">ID</vs-th>
            <vs-th class="bold" sort-key="code">CÓDIGO</vs-th>
            <vs-th class="bold" sort-key="layout_type">LAYOUT</vs-th>
            <vs-th class="bold" sort-key="tag">TAG</vs-th>
            <vs-th class="bold" sort-key="subject">ASUNTO</vs-th>
            <vs-th class="bold" sort-key="subject">COPIA A<br>BACKUP</vs-th>
            <vs-th >ACCIONES</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].id">
                {{ tr.id }}
              </vs-td>
              <vs-td :data="data[indextr].code">
                {{ tr.code }}
              </vs-td>
              <vs-td :data="data[indextr].layout_type">
                {{ layoutName(tr.layout_type) }}
              </vs-td>
              <vs-td :data="data[indextr].tag">
                {{ tr.tag }}
              </vs-td>
              <vs-td :data="data[indextr].subject">
                {{ tr.subject }}
              </vs-td>
              <vs-td :data="data[indextr].copy_to_backup">
                {{ tr.copy_to_backup ? 'Sí' : 'No'}}
              </vs-td>
              <vs-td :data="data[indextr].id">

                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6" @click.stop="editTemplate(data[indextr])" />
                <feather-icon icon="PlayCircleIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6" @click.stop="previewTemplate(data[indextr])" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6" @click.stop="deleteRequest(data[indextr])" />
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>

      <vx-card :title="formTitle" :hidden="!onFormView">
        <div class="vx-row">
          <div :class="colClass">
            <vs-input
              class="w-full"
              label="Código del template *"
              name="code"
              v-validate="requiredRules"
              v-model.lazy="model.code"
              :danger="hasError('code')"
              :danger-text="errorText('code')"
              :success="isSuccess('code')"
              icon-pack="feather"
              :disabled="onShowMode"
            />
          </div>
          <div :class="colClass">
            <vs-input
              class="w-full"
              label="Tag"
              name="tag"
              v-model.lazy="model.tag"
              :danger="hasError('tag')"
              :danger-text="errorText('tag')"
              :success="isSuccess('tag')"
              icon-pack="feather"
              :disabled="onShowMode"
            />
          </div>
          <div :class="colClass">
            <label for="layout_type" class="vs-input--label">Tipo de layout *</label>
            <v-select
              id="layout_type"
              name="layout_type"
              class="vs-custom"
              :class="{'has-error': hasError('layout_type'), 'is-success': isSuccess('layout_type')}"
              v-model.lazy="model.layout_type"
              v-validate="requiredRules"
              :options="layoutTypes"
              :reduce="item => item.value"
              :clearable="false"
              :searchable="false"
              :disabled="onShowMode"
            >
            </v-select>
            <v-error v-if="hasError('layout_type')" :error="errorText('layout_type')" />
          </div>
          <div :class="colClass">
            <vs-input
              class="w-full"
              label="Asunto *"
              v-model.lazy="model.subject"
              name="subject"
              :danger="hasError('subject')"
              :danger-text="errorText('subject')"
              :success="isSuccess('subject')"
              :disabled="onShowMode"
            />
          </div>
          <div :class="colClass">
            <vs-input
              class="w-full"
              label="Inicio/saludo"
              v-model.lazy="model.greeting"
              name="greeting"
              :danger="hasError('greeting')"
              :danger-text="errorText('greeting')"
              :success="isSuccess('greeting')"
              :disabled="onShowMode"
            />
          </div>
          <div :class="colClass">
            <vs-input
              class="w-full"
              label="Resaltado en saludo"
              v-model.lazy="model.greeting_color"
              name="greeting_color"
              :danger="hasError('greeting_color')"
              :danger-text="errorText('greeting_color')"
              :success="isSuccess('greeting_color')"
              :disabled="onShowMode"
            />
          </div>
        </div>

        <div class="vx-row mb-3">
          <div :class="colClass">
            <label for="body" class="vs-input--label">Texto 1 *</label>
            <vx-textarea
              class="w-full"
              id="body"
              v-model.lazy="model.body"
              name="body"
              v-validate="requiredRules"
              :danger="hasError('body')"
              :danger-text="errorText('body')"
              :success="isSuccess('body')"
              height="150px"
              :disabled="onShowMode"
            />
          </div>
          <div :class="colClass" v-if="showSubject2">
            <vs-input
              class="w-full"
              label="Asunto 2"
              v-model.lazy="model.subject2"
              name="subject2"
              :danger="hasError('subject2')"
              :danger-text="errorText('subject2')"
              :success="isSuccess('subject2')"
              :disabled="onShowMode"
            />
          </div>
          <div :class="colClass" v-if="showText2">
            <label for="body" class="vs-input--label">Texto 2</label>
            <vx-textarea
              class="w-full"
              id="body2"
              v-model.lazy="model.body2"
              name="body2"
              :danger="hasError('body2')"
              :danger-text="errorText('body2')"
              :success="isSuccess('body2')"
              height="150px"
              :disabled="onShowMode"
            />
          </div>
          <div :class="colClass">
            <vs-input
              class="w-full"
              label="Call to action"
              v-model.lazy="model.call_to_action"
              name="call_to_action"
              :danger="hasError('call_to_action')"
              :danger-text="errorText('call_to_action')"
              :success="isSuccess('call_to_action')"
              :disabled="onShowMode"
            />
          </div>
          <div :class="colClass">
            <label class="vs-input--label">Enviar copia a backup</label>
            <vs-checkbox
              id="copy_to_backup"
              name="copy_to_backup"
              class="w-full mb-3"
              v-model.lazy="model.copy_to_backup" >
            </vs-checkbox>
          </div>
        </div>

        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <vs-button v-if="!onShowMode" @click="saveRequest" color="primary" class="mr-5">Guardar</vs-button>
            <vs-button v-if="!onShowMode" @click="cancelSave" color="warning">Cancelar</vs-button>
            <vs-button v-if="onShowMode" @click="backToTable" color="success" class="mr-5">Regresar</vs-button>
            <vs-button v-if="onShowMode" @click="editCurrentView" color="primary">Editar</vs-button>
          </div>
        </div>
      </vx-card>

    </div>
  </div>
</template>

<script>
const generalColClass = "vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mb-5";
const midColClass = "vx-col lg:w-1/6 md:w-1/4 sm:w-full w-full mb-5";
import {emailLayoutTypes} from "@mixins/emailLayoutTypes";
export default {
  name: "EmailTemplatesPage",
  mixins: [emailLayoutTypes],
  data(){
    return {
      isMounted: false,
      itemsPerPage: 10,
      itemsPerPageDefinitions: [10,15,20,30,50],
      templates: [],
      currentTemplateId: null,
      currentMode: 0, // vista de tabla
      tableMode: 0,
      showMode: 1,
      newMode: 2,
      editMode: 3,
      colClass: generalColClass,
      midColClass: midColClass,
      requiredRules: 'required',
      newTitle: 'Nueva plantilla',
      model: {
        code: null,
        subject: null,
        subject2: null,
        tag: null,
        layout_type: null,
        greeting: null,
        greeting_color: null,
        body: null,
        body2: null,
        call_to_action: null,
        copy_to_backup: null,
      }
    }
  },
  async mounted(){
    await this.getTemplatesList();
    this.isMounted = true;
  },
  computed: {
    currentPage: {
      get: function(){
        if(this.isMounted){
          return this.$refs.table.currentx;
        }
        return 0;
      },
      set: function (val){
        this.$refs.table.currentx = val;
      }
    },
    onTableView(){
      return this.currentMode === this.tableMode;
    },
    onFormView(){
      return this.currentMode === this.newMode || this.currentMode === this.editMode || this.currentMode === this.showMode;
    },
    onNewMode(){
      return this.currentMode === this.newMode;
    },
    onEditMode(){
      return this.currentMode === this.editMode;
    },
    onShowMode(){
      return this.currentMode === this.showMode;
    },
    formTitle(){
      if(this.onShowMode){
        return `Detalle de plantilla con id ( ID ${this.currentTemplateId} )`;
      }
      else {
        return this.onEditMode ? `Edición de plantilla ( ID ${this.currentTemplateId} )` : this.newTitle;
      }
    },
    layoutTypes(){
      return emailLayoutTypes;
    },
    currentLayoutTypeDef(){
      if(this.model.layout_type !== null){
        return this.layoutTypes.find(f => f.value === this.model.layout_type);
      }
    },
    showSubject2(){
      return this.currentLayoutTypeDef?.subject2 ?? false;
    },
    showText2(){
      return this.currentLayoutTypeDef?.text2 ?? false;
    }
  },
  methods: {
    async getTemplatesList(){
      this.showLoading(true)
      try {
        const res = await axios.get('api/templates/email_templates');
        this.templates = res.data;
      }
      catch (e) {
        this.warn(e);
      }
      this.showLoading(false)
    },
    async startNewReg(){
      this.model = {};
      this.currentMode = this.newMode;
    },
    async backToTable(){
      this.currentMode = this.tableMode;
    },
    async editCurrentView(){
      this.currentMode = this.editMode;
    },
    async editTemplate(model){
      this.model = model;
      this.currentTemplateId = model.id;
      this.currentMode = this.editMode;
    },
    async showTemplate(model){
      this.model = model;
      this.currentTemplateId = model.id;
      this.currentMode = this.showMode;
    },
    async previewTemplate(model){
      const url = `${this.ApiDomain}/api/templates/preview_email/${model.code}?access_token=${this.AccessToken}`
      window.open(url,url,'addressbar=0,directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=0,resizable=0');
    },
    async saveRequest(){
      const validated = await this.$validator.validateAll();
      if(!validated){
        this.missingFieldsNotif();
        return false;
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: this.onNewMode ? "Guardar nueva plantilla" : "Actualizar la plantilla",
        text: "Confirme que desea guardar los datos.",
        acceptText: "Aceptar",
        cancelText: "Cancelar",
        accept:this.doSaveRequest
      });
    },
    async cancelSave(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: this.onNewMode ? "Cancelar alta de plantilla" : "Cancelar actualización de plantilla",
        text: "Confirme que desea cancelar el guardado. Los avances se perderán.",
        acceptText: "Aceptar",
        cancelText: "Cancelar",
        accept:this.doCancelRequest
      });
    },
    async doCancelRequest(){
      this.currentMode = this.tableMode;
      this.model = {};
    },
    async doSaveRequest(){
      this.showLoading(true)
      try {
        const url = this.onNewMode ? 'api/templates/email_templates' : `api/templates/email_templates/${this.currentTemplateId}`;
        const res = await axios.post(url, this.model);
        if(this.onNewMode){
          this.templates.push(res.data);
          this.addSuccessNotif();
        }
        else{
          this.saveSuccessNotif();
        }
        this.currentMode = this.tableMode;
      }
      catch (e) {
        if(e.response && e.response.status === 409){
          this.errorNotifDialog("Error", e.response.data);
        }
        else{
          this.failedOperationNotif();
        }
      }
      this.showLoading(false)
    },
    async deleteRequest(model){
      this.currentTemplateId = model.id;
      let text = `Confirme que desea eliminar el registro con código <<${model.code}>>. `;
      text += "Esta operación no podrá deshacerse y existe riesgo de fallos en el sistema si la plantilla es utlizada en uno o más procesos.";
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: "Eliminar la plantilla de base de datos",
        text: text,
        acceptText: "Eliminar",
        cancelText: "Cancelar",
        accept:this.doDelete
      });
    },
    async doDelete(){
      this.showLoading(true)
      try {
        const url = `api/templates/email_templates/${this.currentTemplateId}`;
        await axios.delete(url);
        this.deleteSuccessNotif();
        this.currentMode = this.tableMode;
        await this.getTemplatesList();
      }
      catch (e){
        if(e.response && e.response.status === 409){
          this.errorNotifDialog("Error", e.response.data);
        }
        else{
          this.failedOperationNotif();
        }
      }
      this.showLoading(false)
    },
    async sendTest(){
      try {
        await axios.post('api/templates/send_example_email');
        this.successNotif("Prueba enviada correctamente");
      }
      catch (e) {
        if(e.response && e.response.status === 409){
          this.errorNotifDialog("Error", e.response.data);
        }
        else{
          this.failedOperationNotif();
        }
      }
    },
    layoutName(type){
      return this.layoutTypes.find(f => f.value == type).label;
    },
    updateItemsPerPage(it){
      this.itemsPerPage = it;
      this.currentPage = 1;
    },
    hasError(val){
      return this.errors.has(val);
    },
    errorText(val){
      return this.errors.first(val);
    },
    isSuccess(val){
      let ff = this.fields[val];
      return (ff && ff.required && ff.valid);
    },
  }

}
</script>
